// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PdpSharedDeposit__wrapper__a63acff2"};